import { render, staticRenderFns } from "./AddLeadDuplicate.vue?vue&type=template&id=25b8bfd4&scoped=true"
import script from "./AddLeadDuplicate.vue?vue&type=script&lang=js"
export * from "./AddLeadDuplicate.vue?vue&type=script&lang=js"
import style0 from "./AddLeadDuplicate.vue?vue&type=style&index=0&id=25b8bfd4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25b8bfd4",
  null
  
)

export default component.exports